import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";
import { StoreSelectorVariantEnum } from "@repo/core/screens/Sales/components/StoreSelector/types";
import { View, VStack } from "@gluestack-ui/themed";
import { DataTable } from "@repo/core/components/core/DataTable";
import { MustShow } from "@repo/core/components/core/MustShow";
import { Modal } from "@repo/core/components/layout/Modal";
import { ReportSelectFilters } from "@repo/core/components/layout/ReportSelectFilters";
import { ReportScreenHeader } from "../../components/ReportScreenHeader";
import { ReasonDenialReportController } from "./controller";
import { ReportCharts } from "@repo/core/components/chart/ReportCharts";
import { getReportCardByReportType } from "../../components/ReportCard/utils";
import { ReportTypeEnum } from "../../types";
import { ReportCardEnum } from "@repo/core/types/reports";
import { EmptyState } from "@repo/core/components/layout/EmptyState";
import Spinner from "@repo/core/components/core/Spinner";
import { ChartVisualizationData } from "@repo/core/components/chart/ReportCharts/types";
const ReasonDenialReport = () => {
  const {
    isMobile,
    onChangeStartDate,
    onChangeEndDate,
    table,
    cardsData,
    handleExportTable,
    filterModalRef,
    topRightText,
    reportTypes,
    selectedReportType,
    onSelectReportType,
    filterStartDate,
    filterEndDate,
    chartBarData,
    handleSelectFilters,
    isFetchingReasonDenialReport,
    hasReportData
  } = ReasonDenialReportController();
  return (
    <Scaffolds.Root showHeader={false}>
      <Scaffolds.StoreSelect
        showHeader={false}
        statusBarVariant={StatusBarVariantEnum.GREEN}
        storeSelectorVariant={StoreSelectorVariantEnum.SHOPKEEPER}
        topRightText={topRightText}
        topRightIcon="refresh"
      >
        <Scaffolds.Page
          showHeader
          pt={!isMobile ? "$3" : "$0"}
          title="Motivos de Negação"
          p="$0"
          bg="$backgroundLight0"
          rightIcon={isMobile ? undefined : "file-export"}
          rightIconSize={20}
          rightWebLabel={isMobile ? undefined : "Exportar"}
          onPressRightIcon={isMobile ? undefined : handleExportTable}
        >
          <VStack flex={1} px={isMobile ? 0 : "$4"} gap={isMobile ? 0 : "$6"}>
            <ReportScreenHeader
              filterModalRef={filterModalRef}
              defaultStartDate={filterStartDate}
              defaultEndDate={filterEndDate}
              onChangeStartDate={onChangeStartDate}
              onChangeEndDate={onChangeEndDate}
              handleSelectFilter={handleSelectFilters}
              reportTypes={reportTypes}
              selectedReportType={selectedReportType}
              onSelectReportType={onSelectReportType}
            />

            <MustShow
              isVisible={!isFetchingReasonDenialReport && hasReportData}
              fallback={
                <MustShow
                  isVisible={isFetchingReasonDenialReport}
                  fallback={
                    <EmptyState
                      flex={1}
                      text="Nenhum relatório disponível para o período selecionado."
                    />
                  }
                >
                  <VStack flex={1} alignItems="center" justifyContent="center">
                    <Spinner size={60} />
                  </VStack>
                </MustShow>
              }
            >
              <ReportCharts.Bar
                isStackedBars
                data={chartBarData?.data as ChartVisualizationData[]}
                maxValue={
                  selectedReportType === ReportTypeEnum.PERCENTAGE ? 100 : 1000
                }
                maxDomain={
                  selectedReportType === ReportTypeEnum.PERCENTAGE ? 70 : 700
                }
                numberOfGridLines={10}
              />

              <MustShow isVisible={!isMobile}>
                <DataTable table={table} />
              </MustShow>

              <MustShow isVisible={isMobile}>
                <VStack>
                  {cardsData?.map((card) =>
                    getReportCardByReportType(
                      ReportCardEnum.REASON_DENIAL,
                      card
                    )
                  )}
                </VStack>
              </MustShow>
            </MustShow>
          </VStack>
        </Scaffolds.Page>
      </Scaffolds.StoreSelect>

      <Modal ref={filterModalRef}>
        <View flex={1} p="$2" bg="$backgroundLight0">
          <ReportSelectFilters
            onClose={() => filterModalRef.current?.close()}
          />
        </View>
      </Modal>
    </Scaffolds.Root>
  );
};
export default ReasonDenialReport;
